export default {
    user: {
        email: 'Email',
        webs: 'Интернет-страницы',
        messengers: 'Мессенджеры',
        welcome: 'Добро пожаловать, %(user)s!',
        register: 'Зарегистрироваться',
        settings: {
            tables: {
                project_worksheet: {
                    sourceForSys: 'Источник поступления в систему'
                }
            }
        }
    },
    profile: {
        privateInfo: {
            title: 'Данные пользователя',
            about: 'Сменив данный пароль, вы также измените пароль для входа в программу Experium.'
        },
        form: {
            currentPassword:       'Старый пароль',
            newPassword:           'Новый пароль',
            passwordRepeat:        'Новый пароль (повтор)',
            updatePassword:        'Обновить пароль',
            passwordChangeSuccess: 'Пароль был успешно изменен',
            needUpdatePassword:    'Для продолжения работы, необходимо сменить временный пароль.'
        },
        avatar: 'Фото профиля',
        edit: 'Редактировать',
        avatar_set: 'Фотография успешно загружена',
        clear: 'Очистить',
        save: 'Сохранить фото',
        header_modal: 'Загрузить фото',
        upload: 'Кликните или переместите файл для загрузки'
    },
};
